import { DndContext, DragOverlay } from '@dnd-kit/core';
import SpinnerBlock from 'components/others/SpinnerBlock';
import ESpinner from 'components/others/Spinner';
import OffTasks from '../../OffTasks';
import TaskCard from '../../TaskCard';
import KanbanCard from './KanbanCard';
import KanbanColumn from './KanbanColumn';
import useKanbanBoard from './model/useKanbanBoard';
import useKanbanTaskMove from './model/useKanbanTaskMove';

const Kanban = () => {
    const board = useKanbanBoard();
    const move = useKanbanTaskMove({
        userId: board.userId,
        columns: board.columns,
        taskById: board.taskById,
        columnOrder: board.columnOrder,
        persistOrder: board.persistOrder,
        triggerListRefresh: board.triggerListRefresh,
        onOpenWithIntent: board.openTaskWithIntent,
    });

    if (board.tasks === null) {
        return (
            <div className="py-5">
                <ESpinner />
            </div>
        );
    }

    return (
        <>
        <SpinnerBlock onlyBlur={true} show={board.showSpinner || move.statusUpdating} />
        <div className="task-kanban position-relative">  
            <DndContext
                sensors={move.sensors}
                collisionDetection={move.collisionDetection}
                onDragStart={move.handleDragStart}
                onDragOver={move.handleDragOver}
                onDragEnd={(e) => void move.handleDragEnd(e)}
                onDragCancel={move.handleDragCancel}
            >
                <div className="task-kanban__scroller">
                    {board.columns.map((col) => (
                        <KanbanColumn
                            key={col.status}
                            status={col.status}
                            tone={col.tone}
                            tasks={col.tasks}
                            onOpenTask={board.openTask}
                            onShowRelatedTasks={board.setRelatedTasks}
                            isDropTarget={
                                move.activeTask != null && move.overColumnStatus === col.status
                            }
                        />
                    ))}
                </div>

                <DragOverlay dropAnimation={null}>
                    {move.activeTask ? (
                        <KanbanCard
                            task={move.activeTask}
                            onOpen={() => undefined}
                            onShowRelatedTasks={() => undefined}
                            overlay
                        />
                    ) : null}
                </DragOverlay>
            </DndContext>

            <TaskCard
                taskId={board.openTaskId}
                onHide={board.hideTaskCard}
                openIntent={board.openIntent}
                onOpenIntentApplied={board.clearOpenIntent}
            />

            <OffTasks
                show={Boolean(board.relatedTasks)}
                onHide={() => board.setRelatedTasks(null)}
                leadId={board.relatedTasks?.leadId ?? null}
                objectId={board.relatedTasks?.objectId ?? null}
                contextName={board.relatedTasks?.contextName ?? null}
            />
        </div>
        </>
    );
};

export default Kanban;
